<template>
    <UBadge
        :color="status.color"
        :label="status.label"
        size="sm"
        variant="subtle"
    />
</template>

<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps({
    status: {
        type: String,
    },
    deletedAt: {
        type: String,
    },
})

const status = computed(() => {
    if (props.status === 'completed') return {label: 'Fullført', color: 'success'}
    if (props.deletedAt) return {label: 'Slettet', color: 'error'}
    return {label: 'Ikke påbegynt', color: 'neutral'}
})

</script>

<style scoped>

</style>